// POST

import axios from 'axios';
import { CreateOrderInput, CreateOrderResult } from 'views/order-feed/features/my-supply-plan/types/create-order-input.type';

// /ewosapi/v1/order/forecast/override
export const postOverrideOrder = async (
  customerErpId: string,
  request: CreateOrderInput
): Promise<CreateOrderResult> => {
  const res = await axios.post<string>(`/ewosapi/v1/order/forecast/override?customerErpId=${customerErpId}`, request);

  return { orderNumber: res.data, createOrderInput: request };
};
